import { ClientModel, ProjectNewModel, UserModel, WorkerModel } from '../modules/models';

export const ROUTES = {
  DASHBOARD: { path: '/', permissionsExpression: '' },
  DASHBOARD_PROJECTS: {
    path: '/dashboard/projects',
    permissionsExpression: UserModel.ProjectsPermission.VIEWACCESS,
  },
  DASHBOARD_CLIENTS: { path: '/dashboard/clients', permissionsExpression: UserModel.ClientsPermission.VIEWACCESS },
  DASHBOARD_WORKERS: { path: '/dashboard/workers', permissionsExpression: UserModel.WorkersPermission.VIEWACCESS },
  DASHBOARD_WFM_EXPANDED: { path: '/dashboard/wfm-expanded', permissionsExpression: '' },
  DASHBOARD_DAILY_LOG_EXPANDED: { path: '/dashboard/daily-log-expanded', permissionsExpression: '' },
  DOWNLOADS: { path: '/downloads', permissionsExpression: '' },
  CLIENT_WIZARD: { path: '/clients/wizard/:id/:step?', permissionsExpression: UserModel.DraftClientsPermission.MANAGE },
  CLIENT_INVITE: { path: '/clients/invite/:id', permissionsExpression: UserModel.DraftClientsPermission.INVITE },
  CLIENT_DETAIL: {
    path: '/clients/detail/:id/:step?',
    permissionsExpression: UserModel.ClientsPermission.VIEWACCESS,
    shouldBeFcaUser: true,
    tabMap: ClientModel.tabMap,
    includeScopedPermissions: false,
  },
  CLIENT_LIST: {
    path: '/clients',
    permissionsExpression: `${UserModel.ClientsPermission.VIEWACCESS} OR ${UserModel.DraftClientsPermission.VIEWACCESS}`,
    shouldBeFcaUser: true,
    includeScopedPermissions: false,
  },
  PROJECT_WIZARD: {
    path: '/projects/wizard/:id/:step?',
    permissionsExpression: UserModel.DraftProjectsPermission.VIEWACCESS,
  },
  PROJECT_DETAIL: {
    path: '/projects/detail/:id/:step?',
    permissionsExpression: UserModel.ProjectsPermission.VIEWACCESS,
    tabMap: ProjectNewModel.tabMap,
  },
  PROJECT_LIST: { path: '/projects', permissionsExpression: UserModel.ProjectsPermission.VIEWACCESS, includeScopedPermissions: true },
  PROJECT_INVITATION: { path: '/projects/invitation/:id/:step?', permissionsExpression: UserModel.ProjectsPermission.ACCEPTSERVICEAGREEMENT },
  // PROCORE_MAPPING: { path: '/procore-clients/client-mapping/:id/:step?', permissionsExpression: UserModel.ProcoreIntegrationsPermission.VIEWACCESS },
  PROCORE_MAPPING: { path: '/procore-clients/client-mapping/:id/:step?', permissionsExpression: '' },
  WORKER_LIST: { path: '/workers', permissionsExpression: UserModel.WorkersPermission.VIEWACCESS, includeScopedPermissions: true },
  WORKER_WIZARD: { path: '/workers/wizard/:id?', permissionsExpression: UserModel.WorkersPermission.MANAGE, includeScopedPermissions: true },
  WORKER_DETAIL: {
    path: '/workers/detail/:id/:step?',
    permissionsExpression: UserModel.WorkersPermission.VIEWACCESS,
    includeScopedPermissions: true,
    tabMap: WorkerModel.tabMap,
  },
  INVENTORY_LIST: { path: '/inventory', permissionsExpression: UserModel.StatisticsPermission.Inventory },
  ACCESS_CONTROL_SYSTEM_WIZARD: {
    path: '/inventory/access-control-system/wizard/:id',
    permissionsExpression: UserModel.AccessControlSystemsPermission.MANAGE,
  },
  BADGE_PRINTER_SYSTEM_WIZARD: {
    path: '/inventory/badge-printing-system/wizard/:id',
    permissionsExpression: UserModel.BadgePrintingSystemsPermission.MANAGE,
  },
  ACCOUNT_SETTINGS: { path: '/account/settings', permissionsExpression: '' },
  PAYMENT_SETTINGS: { path: '/payment/settings', permissionsExpression: UserModel.PaymentMethodsPermission.VIEWACCESS },
  COMPANY_TREE: { path: '/company-tree', permissionsExpression: '' },
  INVOICE_LIST: { path: '/invoices', permissionsExpression: UserModel.InvoicesPermission.VIEWACCESS, includeScopedPermissions: true },
  INVOICE_DETAIL: { path: '/invoices/:detail?/:id', permissionsExpression: UserModel.InvoicesPermission.VIEWACCESS, includeScopedPermissions: true },
  REGISTER: { path: '/users/registration', permissionsExpression: '' },
  FORGOT_PASSWORD: { path: '/forgot-password', permissionsExpression: '' },
  RESET_PASSWORD: { path: '/users/reset-password', permissionsExpression: '' },
  ADMIN: { path: '/admin', permissionsExpression: UserModel.AdminPermission.GENERAL },
  // PROCORE_CLIENTS: { path: '/procore-clients', permissionsExpression: UserModel.ProcoreIntegrationsPermission.VIEWACCESS },
  PROCORE_CLIENTS: { path: '/procore-clients', permissionsExpression: '' },
  CLIENT_ONBOARDING: { path: '/client-onboarding/:id/:step?', permissionsExpression: '' /* UserModel.DraftClientsPermission.MANAGE */ },
  SECURITY: { path: '/security', permissionsExpression: UserModel.AdminPermission.GENERAL, shouldBeFcaUser: true },
  TABLET_EXPERIENCE: {
    path: '/tablet-experience',
    permissionsExpression: UserModel.AppAccessPermission.TABLETEXPERIENCE,
    includeScopedPermissions: true,
  },
  LEARNING: { path: '/learning', permissionsExpression: UserModel.AdminPermission.GENERAL },
  MANAGE_FCA_USERS: { path: '/manage-fca-users', permissionsExpression: UserModel.AdminPermission.SUPER },
  REPORTS_APP: { path: '/reports', permissionsExpression: UserModel.AdminPermission.GENERAL, shouldBeFcaUser: true },
  UNAUTHORIZED: { path: '/unauthorised', permissionsExpression: '' },
  PRODUCT_CATALOG: { path: '/product-catalogs', permissionsExpression: UserModel.AdminPermission.SUPER },
  AUDIT_TRAIL: { path: '/audit-trail', permissionsExpression: UserModel.AdminPermission.GENERAL, shouldBeFcaUser: true },
  PRODUCT_WIZARD: { path: '/product/wizard/:id/:step?', permissionsExpression: UserModel.AdminPermission.SUPER },
  VALIDATE_USER: { path: '/users/verifycontact', permissionsExpression: '' },
  APPROVE_USER: { path: '/CompanyUser/:companyUserId/users/:userId/Company/:companyId/Project/:projectId/ApproveUserApproval', permissionsExpression: '' },
  DENY_USER: { path: '/CompanyUser/:companyUserId/users/:userId/Company/:companyId/Project/:projectId/DenyUserApproval', permissionsExpression: '' },
};
